import { useState } from 'react'
import styles from './Header.module.css'

const NAV_LINKS = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'For employers', href: '#employers' },
  { label: 'For candidates', href: '#candidates' },
  { label: 'Why us', href: '#why-us' },
]

export default function Header() {
  const [open, setOpen] = useState(false)

  return (
    <header className={styles.header}>
      <div className={`container ${styles.bar}`}>
        <a href="#top" className={styles.brand}>
          <img src="/logo.jpg" alt="Virtual Recruiter" className={styles.mark} />
          <span className={styles.brandText}>
            Virtual Recruiter
            <span className={styles.tagline}>Find your next, faster</span>
          </span>
        </a>

        <nav className={styles.nav} aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className={styles.navLink}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className={styles.actions}>
          <a href="#candidates" className={styles.textLink}>Find work</a>
          <a href="#post-role" className={styles.cta}>Post a role</a>
        </div>

        <button
          className={styles.menuButton}
          aria-expanded={open}
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className={styles.menuBar} data-open={open} />
        </button>
      </div>

      {open && (
        <div className={styles.mobileMenu}>
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
          <a href="#post-role" className={styles.cta} onClick={() => setOpen(false)}>
            Post a role
          </a>
        </div>
      )}
    </header>
  )
}
